import { useEffect } from "react";
import { applyProfileThemeToElement } from "../../../design/theme/applyTheme";
import { useThemeOptional } from "../../../design/theme/ThemeProvider";

/**
 * Applies resolved app theme (light/dark) on the profile shell subtree.
 */
export function usePlayerProfileTheme(shellRef, enabled) {
  const themeCtx = useThemeOptional();
  const themeId = themeCtx?.resolvedThemeId ?? "light";

  useEffect(() => {
    if (!enabled) return undefined;
    const el = shellRef.current;
    if (!el) return undefined;
    return applyProfileThemeToElement(el, themeId);
  }, [shellRef, enabled, themeId]);
}
